import React from "react";
import { Modal } from "react-bootstrap";
import ModalHeader from "./../../../EmployeeProfileModal/ModalHeader";
import "./../../OverideModal.css";
import { FormSection, FormFieldGroup } from "component-library/formSections";

const NewTerminationReasonModal = ({
  show,
  onCancel,
  onAddTerminationReason,
  data,
  onChangeModal
}) => (
  <Modal
    id="termination-modal"
    bsClass="termination-modal entity-page-cancel-modal modal"
    animation={false}
    backdrop={"static"}
    keyboard={false}
    show={show}
    onHide={onCancel}
    restoreFocus={false}
  >
    <ModalHeader onClose={onCancel} />
    <Modal.Body>
      <div id="termination-modal-body" className="modal-row">
        <div className="modal-header">New Termination Reason</div>

        <div style={{ marginBottom: "20px" }}>
          Did'nt see the correct termination reason available for this employee?
          Add a new one below to your compnay.
        </div>
        <FormSection>
          <FormFieldGroup
            inputName="newTerminationReason"
            label="Name this new termination reason"
            description="Ex. Attendance, Laid Off etc."
            descriptionStyle="italic"
            labelFontWeight="600"
            value={data.newTerminationReason}
            onChange={onChangeModal}
          />
        </FormSection>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div
        id="cancel-modal-footer"
        className="button-group"
        style={{ textAlign: "left" }}
      >
        <button
          type="button"
          id="save-modal-button"
          className={
            !data.newTerminationReason
              ? "disabled-button"
              : "nc-button primary-button"
          }
          onClick={onAddTerminationReason}
        >
          ADD TERMINATION REASON
        </button>

        <button
          type="button"
          id="save-modal-button"
          className="nc-button secondary-link-button"
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </Modal.Footer>
  </Modal>
);
export default NewTerminationReasonModal;
